<template>
    <rkm-form
        ref="Form"
        show-legend
    >
        <rkm-area
            title="Identificação"
            type="section"
        >
            <rkm-row>
                <rkm-col>
                    <rkm-form-input
                        :validations="validations.cnpj"
                        autofocus
                        label="CNPJ"
                        placeholder="99.999.999/9999-99"
                        uppercase
                        v-mask="mask.cnpj"
                        v-model="model.cnpj"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                    <rkm-form-input
                        :validations="validations.nomeFantasia"
                        label="Nome fantasia"
                        v-model="model.nomeFantasia"
                        uppercase
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                    <rkm-form-input
                        :validations="validations.razaoSocial"
                        label="Razão social"
                        v-model="model.razaoSocial"
                        uppercase
                    />
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-area
            title="Contato"
            type="section"
        >
            <rkm-row>
                <rkm-col>
                    <rkm-form-input
                        :validations="validations.email"
                        label="E-mail"
                        placeholder="email@email.com.br"
                        v-model="model.email"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                    <rkm-form-input
                        :validations="validations.site"
                        label="Site"
                        v-model="model.site"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-area>
    </rkm-form>
</template>

<script>
// Mixins.
import { mask } from '@/mixins'

export default {
    mixins: [ mask ],
    props: {
        model: { type: Object, required: true },
    },
    computed: {
        validations() {
            return {
                cnpj: {
                    min_max_without_mask: 14,
                    cnpj: true,
                },
                nomeFantasia: {
                    required: true,
                    min: 3,
                    max: 255,
                },
                razaoSocial: {
                    required: true,
                    min: 3,
                    max: 255,
                },
                email: { email: true, max: 180 },
                site: { max: 180, url: true },
            }
        },
    },
    methods: {
        async validate() {

            return await this.$refs.Form.validate()
        },
    },
}
</script>